<script setup lang="ts">
  import {ref, computed} from 'vue';
  import { useI18n } from '@/hooks/web/useI18n';
  const { t } = useI18n()

  const emit = defineEmits([])
  const props = defineProps({
    title: {type: String, required: false},
    expand: {type: Boolean, default: false},
    disCollapse: {type: [Object,Boolean], default: false},
    flex: {type: Boolean, default: false},
  })
  const _expand = ref(props.expand)
  const onExpand = ()=>{
    _expand.value = !_expand.value
  }
</script>

<template>
  <div class="collapse" :style="{height: 'auto'}">
    <div class="collapse-head">
      <div class="collapse-lft">
        <span v-if="!disCollapse" @click.stop="onExpand" class="collapse-icon">
          <el-icon v-if="_expand"><CaretBottom /></el-icon>
          <el-icon v-else><CaretRight /></el-icon>
        </span>        
        <span class="collapse-title">{{props.title}}</span>
        <span>
          <slot name="lftSlot"></slot>
        </span>
      </div>
      <div>
        <slot name="rtSlot"></slot>
      </div>      
    </div>
    <div 
      v-show="_expand||disCollapse" 
      :class="['collapse-body', flex?'collapse-body-flex':'','collapse-body-grid']">
      <slot></slot>
    </div>
  </div>
</template>
<style lang="scss">
// .collapse-body-flex{
//   .row{
//     display: flex;
//     flex-wrap: wrap;
//     gap:24px;
//     &>div,.col1,.col2,.col3,.col4,.col5,.col6,.col7,.col8,.col9,.col10,.col11,.col12{
//       display: block;
//       flex:1;
//       max-width: 100%;
//     }
//     .col1{
//       max-width: 8.333333333%;
//       flex: 0 0 8.333333333%;
//     }
//     .col2{
//       max-width: 16.666666667%;
//       flex: 0 0 16.666666667%;
//     }
//     .col3{
//       max-width: 25%;
//       flex: 0 0 25%;
//     }
//     .col4{
//       max-width: 33.333333333%;
//       flex: 0 0 33.333333333%;
//     }
//     .col5{
//       max-width: 41.666666667%;
//       flex: 0 0 41.666666667%;
//     }
//     .col6{
//       max-width: 50%;
//       flex: 0 0 50%;
//     }
//     .col7{
//       max-width: 58.333333333%;
//       flex: 0 0 58.333333333%;
//     }
//     .col8{
//       max-width: 66.666666667%;
//       flex: 0 0 66.666666667%;
//     }
//     .col9{
//       max-width: 75%;
//       flex: 0 0 75%;
//     }
//     .col10{
//       max-width: 83.333333333%;
//       flex: 0 0 83.333333333%;
//     }
//     .col11{
//       max-width: 91.666666667%;
//       flex: 0 0 91.666666667%;
//     }
//     .col12{
//       max-width: 100%;
//       flex: 0 0 100%;
//     }
//   }
// }
</style>
<style lang="less" scoped>
.collapse{
  // display: flex;
  // flex-direction: column;
  &-head{
    max-height: 48px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 0px;
  }
  &-icon{
    cursor: pointer;
    color: #89898A;
  }
  &-title{
    color: var(--text-on_subtle-general-primary, #323233);
    font-size: var(--font_size-16, 16px);
    font-style: normal;
    font-weight: 700;
    line-height: var(--font_size-24, 24px);
  }
  &-lft, &-rt{
    display: flex;
    align-items: center;
    gap:8px; 
  }
}
</style>